import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

const headersData = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: getAuthorizationHeader(),
};

interface CreateAlertWorkSupportBody {
  end_at: string;
  start_at: string;
  text: string;
  title: string;
}

interface AlertType {
  id: number;
  title: string;
  text: string;
  start_at: string;
  end_at: string | null;
  created_at: string;
}

interface bodyType {
  page?: number;
  per_page?: number;
}

export const alertsWorkSupportApi = createApi({
  reducerPath: 'alertsWorkSupportApi',
  tagTypes: ['AlertsWorkSupport', 'AlertWorkSupport'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getAlertsWorkSupport: build.query<any, bodyType>({
      query: ({ page, per_page }) => ({
        url: '/notifications',
        method: 'GET',
        params: { page, per_page },
      }),
      providesTags: () => ['AlertsWorkSupport'],
    }),
    getAlertsCastomer: build.query<any, void>({
      query: () => ({
        url: '/notifications',
        method: 'GET',
      }),
      providesTags: () => ['AlertsWorkSupport'],
    }),
    getAlertWorkSupport: build.query<AlertType, { id: string }>({
      query: ({ id }) => {
        const token = localStorage.getItem('token');
        const Authorization = token ? `Bearer ${token}` : undefined;
        return {
          url: `/api/notifications/${id}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization,
          },
        };
      },
      providesTags: () => ['AlertWorkSupport'],
    }),
    createAlertWorkSupport: build.mutation<AlertType, CreateAlertWorkSupportBody>({
      query: (body) => ({
        url: '/notifications',
        method: 'POST',
        body,
        headers: headersData,
      }),
      invalidatesTags: ['AlertsWorkSupport'],
    }),
    updateAlertWorkSupport: build.mutation<
      AlertType,
      { id: string; body: CreateAlertWorkSupportBody }
    >({
      query: (body) => ({
        url: `/notifications/${body.id}`,
        method: 'PUT',
        body: body.body,
        headers: headersData,
      }),
      invalidatesTags: ['AlertsWorkSupport'],
    }),
    canselAlertWorkSupport: build.mutation<AlertType, { id: string }>({
      query: (body) => ({
        url: `/notifications/${body.id}`,
        method: 'PUT',
        body: { start_at: null, end_at: null },
        headers: headersData,
      }),
      invalidatesTags: ['AlertsWorkSupport'],
    }),
  }),
});

export const {
  useGetAlertsWorkSupportQuery,
  useGetAlertWorkSupportQuery,
  useCreateAlertWorkSupportMutation,
  useUpdateAlertWorkSupportMutation,
  useCanselAlertWorkSupportMutation,
  useGetAlertsCastomerQuery,
} = alertsWorkSupportApi;
